<template>
<AuthenticatedLayout>
    <!-- Filtro de Período -->
    <el-form label-position="top">
        <el-row :gutter="20">
        
            <!-- Filtro por Responsável -->
            <el-col :xs="24" :md="12" :lg="6">
                <el-form-item label="Responsável">
                <el-select 
                    filterable
                    multiple
                    v-model="filterForm.users" 
                    placeholder="Selecione um responsável" clearable
                >
                    <el-option 
                    v-for="person in activeUsers" 
                    :key="person.id" 
                    :label="person.name" 
                    :value="person.id" />
                </el-select>
                </el-form-item>
            </el-col>

            <!-- Filtro por Cliente -->
            <el-col :xs="24" :md="12" :lg="6">
                <el-form-item label="Cliente">
                  <el-select 
                    filterable
                    multiple
                    v-model="filterForm.clients" 
                    placeholder="Selecione um cliente" 
                    clearable
                >
                    <el-option 
                      v-for="client in activeClients" 
                      :key="client.id" 
                      :label="client.name" 
                      :value="client.id" />
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :md="12" :lg="6">
                <el-form-item label="Data Inicial">
                    <el-date-picker
                        v-model="filterForm.startDate"
                        type="date"
                        placeholder="Selecione a data inicial"
                    />
                </el-form-item>
              </el-col>

              <el-col :xs="24" :md="12" :lg="6">
                <el-form-item label="Data Final">
                    <el-date-picker
                        v-model="filterForm.endDate"
                        type="date"
                        placeholder="Selecione a data final"
                    />
                </el-form-item>
              </el-col>

              <el-button type="primary" @click="fetchReport">Gerar Relatório</el-button>
        </el-row>
                
        <el-form-item>
            
        </el-form-item>
    </el-form>

    <!-- Total de Horas Trabalhadas -->
     <el-row :gutter="20">
        <el-col :xs="24" :md="12" :lg="6">
            <el-card v-if="reportData.success" class="total-hours-card">
                <h3>Total de Horas Trabalhadas</h3>
                <p>{{ reportData.total_hours }}</p>
            </el-card>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
            <el-card v-if="reportData.success" class="total-hours-card">
                <h3>Total de Tarefas Trabalhadas</h3>
                <p>{{ reportData.lists.length }}</p>
            </el-card>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
            <el-card v-if="reportData.success" class="total-hours-card">
                <h3>Custo total de Trabalho</h3>
                <p>{{ reportData.total_cost }}</p>
            </el-card>
        </el-col>
    </el-row>

    <!-- Tabela de Tarefas -->
    <el-table :data="reportData.lists" style="width: 100%" v-if="reportData.success">
        <el-table-column prop="title" label="Tarefa" />
        <el-table-column prop="client_name" label="Cliente" />
        <el-table-column prop="responsible_name" label="Responsável" />
        <el-table-column prop="stage_name" label="Responsável" />
        <el-table-column 
            prop="start_date" 
            label="Data de Início" 
            :formatter="formatDate" 
        />
        <el-table-column 
            prop="expected_date" 
            label="Data Prevista" 
            :formatter="formatDate" 
        />
        <el-table-column 
            prop="completion_date" 
            label="Data de Conclusão" 
            :formatter="formatDate" 
        />
        <el-table-column prop="total_time" label="Tempo Trabalhado" />        
        <el-table-column 
            prop="task_cost" 
            label="Custo da Tarefa" 
            :formatter="formatCurrency" 
        />        
    </el-table>
</AuthenticatedLayout>
</template>
  
<script>
import AuthenticatedLayout from '@/layouts/AuthenticatedLayout';
import { reportWorkTime } from '@/services/reportService';
import { mapGetters } from 'vuex';

export default {
components: {
    AuthenticatedLayout,
},
data() {
    return {
        filterForm: {
            startDate: new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().substr(0, 10),
            endDate: new Date().toISOString().substr(0, 10),
            users: [],
            clients: [],
        },
        reportData: {
            success: false,
            total_hours: '',
            total_seconds: 0,
            lists: [],
        },
    };
},
computed: {
    ...mapGetters('taskData', [        
        'activeUsers',
        'activeClients',
    ])
},
methods: {
    async fetchReport() {
        try {
            const response = await reportWorkTime(this.filterForm);

            this.reportData = response; // Acessar a propriedade 'data' da resposta            

        } catch (error) {
            console.error(error);
            this.$message.error('Erro ao buscar relatório');
        }
    },
    formatDate(row, column, cellValue) {
        if (!cellValue) return '';
        const date = new Date(cellValue);
        return date.toLocaleDateString('pt-BR');
    },
    formatCurrency(row, column, cellValue) {
        if (!cellValue) return '';
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cellValue);
    },
},
};
</script>
  
<style scoped>
.total-hours-card {
    margin-bottom: 20px;
    padding: 15px;
    background-color: #f5f7fa;
    border-radius: 4px;
}
.total-hours-card h3 {
    margin: 0;
    font-size: 18px;
    font-weight: bold;
}
.total-hours-card p {
    margin: 10px 0 0;
    font-size: 16px;
    color: #606266;
}
</style>